import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { RatingDelta } from "./StarRating";

const Stat = ({ label, value, sub, tone }) => (
  <div className="min-w-[110px]">
    <p className="text-[0.62rem] uppercase tracking-[0.12em] text-muted-foreground font-medium">{label}</p>
    <p className={cn("font-serif text-xl leading-tight tabular", tone)}>{value}</p>
    {sub && <p className="text-[0.68rem] text-muted-foreground truncate max-w-[160px]">{sub}</p>}
  </div>
);

/* Group Ratings Overview — weighted by review count, per function lens */
export const RatingsOverviewPanel = ({ overview }) => {
  if (!overview) return null;
  const fns = Object.keys(overview);
  return (
    <Card data-testid="ratings-overview-panel">
      <CardContent className="py-3.5 space-y-3">
        {fns.map((fn) => {
          const o = overview[fn];
          return (
            <div key={fn} className="flex flex-wrap items-center gap-x-8 gap-y-2" data-testid={`ratings-overview-${fn.toLowerCase()}`}>
              <span className="flex items-center gap-2 text-xs uppercase tracking-[0.12em] font-medium text-[hsl(var(--cx-navy))] w-20">
                <Star size={14} className="text-[hsl(var(--cx-gold))]" fill="currentColor" strokeWidth={0} /> {fn}
              </span>
              <Stat label="Group avg (weighted)" value={o.weighted_avg !== null ? `${o.weighted_avg.toFixed(2)} ★` : "—"}
                sub={`${o.listings} listings · ${o.total_reviews.toLocaleString()} reviews`} />
              <Stat label="New reviews MTD" value={`+${o.new_reviews_mtd}`} />
              {o.best && <Stat label="Best rated" value={`${o.best.rating.toFixed(1)} ★`} sub={o.best.name} tone="text-[hsl(var(--status-green))]" />}
              {o.worst && <Stat label="Lowest rated" value={`${o.worst.rating.toFixed(1)} ★`} sub={o.worst.name} tone="text-[hsl(var(--cx-crimson))]" />}
              {o.mover_up && (
                <div className="min-w-[110px]">
                  <p className="text-[0.62rem] uppercase tracking-[0.12em] text-muted-foreground font-medium">Biggest mover ▲</p>
                  <p className="text-sm font-medium truncate max-w-[150px]">{o.mover_up.name}</p>
                  <RatingDelta delta={o.mover_up.delta} />
                </div>
              )}
              {o.mover_down && (
                <div className="min-w-[110px]">
                  <p className="text-[0.62rem] uppercase tracking-[0.12em] text-muted-foreground font-medium">Biggest mover ▼</p>
                  <p className="text-sm font-medium truncate max-w-[150px]">{o.mover_down.name}</p>
                  <RatingDelta delta={o.mover_down.delta} />
                </div>
              )}
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
